module.exports = __webpack_public_path__ + "static/media/firstPrototype.e5cb6776.png";